import React, { useState } from "react";
import { TableContext } from "../index";
import { debug } from "../utils";
import { useHistory } from "react-router-dom";
import RecentViolationsTableHeader from "./RecentViolationsTableHeader";
import RecentViolationsTable from "./RecentViolationsTable";
import RecentViolationsTableManagement from "./RecentViolationsTableManagement";
import PaginationManager from "../view/PaginationManager";
import * as ruleService from "../rules/ruleService";
import { initShowChangesConfig } from "./HighlightManagement";

function RecentViolationsTableSection(props) {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        filtersLoading: true,
        isLoading: true,
        showChanges: initShowChangesConfig,
        showRemediated: false
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <RecentViolationsTableManagement />
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <RecentViolationsTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <RecentViolationsTable />
                                            <PaginationManager
                                                key="recent-violations"
                                                getPage={ruleService.validationResultListRecentViolationPageable}
                                                blocked={tableConfig.filtersLoading} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default RecentViolationsTableSection;
